var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cn from 'classnames';
export const SortCell = (_a) => {
    var { children, active, ascending, className, describedBy, empty, onClick, joined = false, focused, unfocusable, onFocus, onBlur } = _a, props = __rest(_a, ["children", "active", "ascending", "className", "describedBy", "empty", "onClick", "joined", "focused", "unfocusable", "onFocus", "onBlur"]);
    const cellContent = !empty && (React.createElement("a", { key: `a${props.id}`, href: "/#", onClick: e => e.preventDefault(), "aria-describedby": !joined ? describedBy : undefined, role: "button", tabIndex: unfocusable ? -1 : 0, onFocus: onFocus, onBlur: onBlur, className: cn(focused && 'focused') },
        children ? React.createElement("span", null, children) : null,
        React.createElement("span", { className: cn('cb-icon', active ? `cb-sort-${ascending ? 'asc' : 'desc'}` : 'cb-sort') }, !joined && (React.createElement("span", { className: "sr-only" },
            "Click to sort in ",
            active && ascending ? 'descending' : 'ascending',
            " order")))));
    return React.createElement(joined ? 'th' : 'td', Object.assign(Object.assign({}, props), { className: cn(`cb-table-sort${joined ? '-joined' : ''}`, className), onClick: (e) => {
            e.stopPropagation();
            if (!empty)
                onClick();
        }, onKeyPress: e => {
            if (e.which === 32 && !empty) {
                e.preventDefault();
                onClick();
            }
        } }), [cellContent]);
};
//# sourceMappingURL=SortCell.js.map